import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import TrackBox from "../../Components/Elements/TrackBox";
import Button from "react-bootstrap/Button";

const TracksRecent = ({ tracks }) => (
  <Row className="recent-tracks" style={{ marginBottom: "40px" }}>
    <Col xs={12}>
      <h2 className="page-header">
        <FontAwesomeIcon icon="flag" className="flag" /> Previous Tracks of the Day
      </h2>
    </Col>
    <Col xs={12}>
      <Row>
        {tracks &&
          tracks.map((track) => {
            return (
              <Col xs={12} sm={6} md={4} key={track.id}>
                <TrackBox track={track} />
              </Col>
            );
          })}
      </Row>
    </Col>
    <Col xs={12} className="text-center" style={{ margin: "40px 0 20px 0" }}>
      <Button variant="outline-secondary">
        <Link to={`/archive`} onClick={() => window.gtag('event', 'totd_click', { eventLabel: `Track Archive` })}>Track Archive</Link>
      </Button>
    </Col>
  </Row>
);

TracksRecent.propTypes = {
  tracks: PropTypes.array,
};

TracksRecent.defaultProps = {
  tracks: [],
};

export default TracksRecent;
